/* The Honey Colony — Shopify layer.
   Replaces the prototype's local "preview bag" with the real Shopify cart, shows live
   prices, sends enquiry briefs to the store inbox, connects uploaded films, then starts
   the story app. Loaded after assets/thc-app.js. */
(function () {
  'use strict';
  var T = window.THC;
  var P = T.products || {};
  var byProduct = {};
  Object.keys(P).forEach(function (id) { if (P[id]) byProduct[P[id].productId] = id; });

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = String(T.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var v = (Number(cents) || 0) / 100;
    function num(d, t, dec) {
      var parts = v.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return d ? parts.join(dec) : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        default: return num(2, ',', '.');
      }
    });
  }
  T.formatMoney = formatMoney;
  var h = function (s) { return esc(s == null ? '' : s); };

  /* ---------- Cart ---------- */
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function cartOpen() { var d = $('#dialog'); return d.open && d.classList.contains('cart-drawer'); }
  function sync() {
    updateQty();
    if (cartOpen()) $('#dialog-content').innerHTML = bagHtml();
  }
  function fetchCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if(!r.ok) throw new Error('Shopify is busy. Please wait a moment and refresh your bag.'); return r.json(); })
      .then(function (c) { T.cart = c; sync(); return c; });
  }
  T.refreshCart = fetchCart;
  function bump() {
    var b = $('.bag-button'); if (!b) return;
    b.classList.remove('bag-bump'); void b.offsetWidth; b.classList.add('bag-bump');
  }
  function addItems(id, qty, plan) {
    var sp = P[id], name = getProduct(id).name;
    if (!sp || !sp.variant) { toast(name + ' isn’t available to order online yet.'); return Promise.resolve(false); }
    if (!sp.available || !(sp.priceCents > 0)) { toast(T.strings.sold_out); return Promise.resolve(false); }
    var item = { id: sp.variant, quantity: qty || 1 };
    var message = document.querySelector('[data-live-message]');
    if (message && message.value.trim()) item.properties = { 'Gift message': message.value.trim() };
    if(id==='clover') item.properties=Object.assign({},item.properties||{},{'Preorder':'Tasmanian Clover Honey · coming soon','Fulfilment from':'16 December 2026'});
    if (plan) item.selling_plan = plan;
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'That couldn’t be added to your bag.'); return j; }); })
      .then(function () { return fetchCart(); })
      .then(function () { if(T.syncPreorderNote) return T.syncPreorderNote(T.cart); }).then(function () { bump(); document.dispatchEvent(new CustomEvent('thc:cart-added')); return true; })
      .catch(function (err) { toast(err.message); return false; });
  }

  // The prototype's add-to-bag functions are replaced with Shopify versions.
  addCart = function (id, q) {
    addItems(id, q || 1).then(function (ok) { if (ok) toast(getProduct(id).name + ' added to your bag.'); });
  };
  addPurchase = function () {
    var p = getProduct(state.selectedId), sp = P[p.id], plan = null, note = '';
    var planSelect = document.querySelector('[data-live-plan]');
    plan = planSelect && planSelect.value ? planSelect.value : null;
    addItems(p.id, state.qty, plan).then(function (ok) {
      if (ok) toast(p.name + (plan ? ' · monthly subscription' : '') + ' added to your bag' + note + '.');
    });
  };
  updateQty = function () {
    state.bag = T.cart ? T.cart.item_count : 0;
    v1Qty();
  };
  bagHtml = function () {
    var c = T.cart || { items: [], item_count: 0, total_price: 0 }, items = c.items || [];
    var head = '<p class="eyebrow">YOUR BAG</p><h2 id="dialog-title" class="dialog-title">' +
      (items.length ? 'Good things,<br>coming together.' : 'A little room<br>for discovery.') + '</h2>';
    if (!items.length) {
      return head + '<p>There’s a whole story in a single jar.</p><button class="btn" data-go="collection" data-target="shop-range">Keep exploring ↗</button>';
    }
    var rows = items.map(function (it) {
      var pid = byProduct[it.product_id], p = pid ? getProduct(pid) : null;
      var img = it.image || (p ? p.image : '');
      var name = h(it.product_title);
      var bits = [];
      if (!it.product_has_only_default_variant && it.variant_title) bits.push(h(it.variant_title));
      bits.push(it.selling_plan_allocation ? h(it.selling_plan_allocation.selling_plan.name) : 'One-time purchase');
      return '<div class="cart-row"><a href="' + h(it.url) + '">' + (img ? '<img src="' + h(img) + '" alt="' + name + '">' : '') + '</a><div>' +
        '<h3><a href="' + h(it.url) + '">' + name + '</a></h3><p>' + bits.join(' · ') + '</p>' +
        '<dl class="thc-cart-properties">' + Object.entries(it.properties || {}).filter(function(pair){return pair[0][0] !== '_' && pair[1];}).map(function(pair){return '<dt>'+h(pair[0])+'</dt><dd>'+h(pair[1])+'</dd>';}).join('') + '</dl>' +
        '<p class="caption">' + formatMoney(it.final_line_price) + '</p>' +
        '<div class="cart-controls">' + (it.properties && it.properties._thcGiftRole === 'card' ?
        '<span>One card per gift jar · '+it.quantity+'</span><button class="thc-remove" data-thc-line="'+h(it.key)+'" data-thc-qty="0">Remove card</button>' :
        '<button data-thc-line="' + h(it.key) + '" data-thc-qty="' + (it.quantity - 1) + '" aria-label="Decrease ' + name + ' quantity">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button data-thc-line="' + h(it.key) + '" data-thc-qty="' + (it.quantity + 1) + '" aria-label="Increase ' + name + ' quantity">+</button>' +
        '<button class="thc-remove" data-thc-line="' + h(it.key) + '" data-thc-qty="0">Remove</button>')+'</div></div></div>';
    }).join('');
    var november = items.some(function(item) { return item.product_title.indexOf('16 November 2026') !== -1; });
    var december = items.some(function(item) { return item.handle === 'tasmanian-clover-honey'; });
    var preorder = november || december ? '<div class="thc-preorder-notice" aria-label="Preorder fulfilment"><strong>Preorder sale</strong>' +
      (november ? '<p>Fulfilment starts 16 November 2026.</p>' : '') +
      (december ? '<p>Tasmanian Clover fulfils from 16 December 2026.</p>' : '') + '</div>' : '';
    return head + preorder + '<div class="cart-items">' + rows + '</div>' +
      '<div class="cart-summary"><span>' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's') + '</span><b>' + formatMoney(c.total_price) + '</b></div>' +
      '<p class="concept-note">Shipping and taxes are calculated at checkout.</p>' +
      '<form action="' + h(T.routes.cart) + '" method="post" class="thc-checkout"><button class="btn" type="submit" name="checkout">Checkout ↗</button></form>' +
      '<p><a class="text-link" href="' + h(T.routes.cart) + '">View full bag</a> · <button class="text-link" data-go="collection" data-target="shop-range">Keep exploring</button></p>';
  };

  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-thc-line]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    b.disabled = true;
    fetch(T.routes.cartChange + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: b.dataset.thcLine, quantity: Math.max(0, Number(b.dataset.thcQty)) }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Your bag couldn’t be updated.'); return j; }); })
      .then(function (c) { return T.syncGiftNote ? T.syncGiftNote(c) : c; })
      .then(function (c) { T.cart = c; sync(); if(document.querySelector('form.thc-cart')){location.reload();return;} var x = $('.close-dialog'); if (x) x.focus(); })
      .catch(function (err) { toast(err.message); b.disabled = false; });
  }, true);

  // Standard (non-designed) product pages: add to bag without leaving the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-thc-native-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'That couldn’t be added to your bag.'); return j; }); })
      .then(function () { return fetchCart(); })
      .then(function () { if(T.syncPreorderNote) return T.syncPreorderNote(T.cart); }).then(function () { bump(); document.dispatchEvent(new CustomEvent('thc:cart-added')); openModal('bag'); })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Live prices in the designed pages ---------- */
  var PHRASES = /(Final pricing to follow|Pricing to be confirmed|Pricing to follow|Price to be confirmed|Price to follow)/;
  function priceFor(id) {
    var sp = P[id];
    if (!sp) return 'Coming soon';
    return (sp.compareAt ? sp.compareAt.replace(/<[^>]*>/g, '') + ' → ' : '') + sp.price.replace(/<[^>]*>/g, '') + (sp.available ? '' : ' · Sold out');
  }
  function fillPrices(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return PHRASES.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var el = n.parentElement, id = null;
      var card = el.closest('[data-product]'); if (card) id = card.dataset.product;
      var quick = !id && el.closest('[data-quick]'); if (quick) id = quick.dataset.quick;
      var td = !id && el.closest('td');
      if (td) { var cells = [].filter.call(td.parentElement.children, function (x) { return x.tagName === 'TD'; }); id = state.compare[cells.indexOf(td)]; }
      if (!id && state.page === 'product') id = state.selectedId;
      var label = el.closest('label');
      var isSub = !!(label && label.querySelector('input[value="subscription"]'));
      var text = '';
      if (id) text = isSub ? (P[id] && P[id].plans.length ? 'From ' + P[id].price.replace(/<[^>]*>/g, '') : 'Not yet available') : priceFor(id);
      n.nodeValue = text ? n.nodeValue.replace(PHRASES, text) : n.nodeValue.replace(/\s*·\s*(?=(Final pricing|Pricing|Price) )/, '').replace(PHRASES, '');
    });
  }
  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    requestAnimationFrame(function () { pending = false; fillPrices($('#main')); fillPrices($('#dialog')); });
  }
  var mo = new MutationObserver(schedule);
  mo.observe($('#main'), { childList: true, subtree: true, characterData: true });
  mo.observe($('#dialog'), { childList: true, subtree: true, characterData: true });

  /* ---------- Enquiries: send the reviewed brief to the store inbox ---------- */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-thc-send]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var wholesale = b.dataset.thcSend === 'wholesale';
    var form = wholesale ? $('#wh-enquiry-form') : $('#gp-form');
    if (!form || !form.reportValidity()) return;
    var review = wholesale ? $('#wh-review-text') : $('[data-gp-review]');
    var type = wholesale ? 'Wholesale enquiry' : state.page === 'wedding-favours' ? 'Wedding favours brief' : 'Corporate gifting brief';
    var c = $('#thc-contact-form');
    c.elements['contact[name]'].value = (form.elements.contact && form.elements.contact.value) || '';
    c.elements['contact[email]'].value = (form.elements.email && form.elements.email.value) || '';
    c.elements['contact[Enquiry type]'].value = type;
    c.elements['contact[body]'].value = (review ? review.textContent : '').replace('Prototype draft — not sent', '').trim() + '\n\nSent from: ' + location.href;
    b.disabled = true; b.textContent = 'Sending…';
    c.submit();
  }, true);

  function contactStatus() {
    var el = document.querySelector('[data-thc-contact-status]');
    var status = el ? el.dataset.thcContactStatus : '';
    if (/[?&]contact_posted=true/.test(location.search)) status = 'sent';
    if (status === 'sent') setTimeout(function () { toast('Thank you. Your enquiry is with our team, and we’ll be in touch soon.'); }, 600);
    if (status === 'error') setTimeout(function () { toast('Your enquiry couldn’t be sent. Please check your email address and try again.'); }, 600);
  }

  /* ---------- Films uploaded in theme settings ---------- */
  var films = T.editionFilms || {};
  Object.keys(films).forEach(function (k) { if (films[k]) editionVideos[k] = films[k]; });
  previewVideo = films.manuka || '';

  /* ---------- Boot ---------- */
  state.cart = {}; state.subCart = {};
  if (!T.native) {
    render();
  } else {
    document.body.dataset.page = 'shop';
    try { syncMotion(); } catch (err) { /* decorative only */ }
  }
  updateQty();
  fetchCart().catch(function () {});
  schedule();
  contactStatus();
})();
